module.exports = __webpack_public_path__ + "static/font-1e6fdfc662234081273aaa54de092cdc.eot";